<template>
<div>
    <Breadcrumbs main="Sales" title="Order Create" />
    <!-- Container-fluid starts-->

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Quotation</label>
                                        <!-- <select class="form-control digits" v-model="order.quotation">
                                            <option v-for="(quotation, index) in quotations" :key="index" :value="quotation.id">{{ quotation.quotation_id }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="quotations" label="quotation_id" :reduce="quotation => quotation.id" v-model="order.quotation" placeholder="Select a quotation"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="order.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="projects" label="title" :reduce="project => project.id" v-model="order.project" placeholder="Select a project"></v-select>
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client <span><button class="btn-success ml-3" v-b-modal.modal-prevent-closing>Add New</button></span></label>
                                        <!-- <select class="form-control digits" v-model="order.client" @change="getClient">
                                            <option v-for="(client, index) in clients" :key="index" :value="client.user.id">{{ client.company_name }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="clients" label="company_name" :reduce="client => client.user.id" v-model="order.client" placeholder="Select a client"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <!-- <select class="form-control digits" v-model="order.currency">
                                            <option v-for="(currency, index) in currencies" :key="index">{{ currency }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="currencies" v-model="order.currency" placeholder="Select a currency"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="order.email">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client Address</label>
                                        <input class="form-control" type="text" placeholder="Enter quotation address" v-model="order.client_address">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="order.billing_address">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Order Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="order.order_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="order.due_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="order.order_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items <span style="color: red;">*</span></label>
                                        <ItemTable style="margin-bottom: 10px;" id="item-table" v-if="order.details && order.details.length"
                                        :key="order.details.length" :tableData="order.details" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="order.total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="order.vat_type">
                                                    <option disabled value="">Select Vat Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>

                                            </div>

                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" v-model="order.vat" />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>

                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Tax -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="order.tax_type">
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>

                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>

                                            </div>

                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" v-model="order.tax" />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>
                                            </div>

                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>

                                    </div>

                                    <!-- Discount -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control w-50" type="number" placeholder="Enter discount (%)" v-model="order.discount" />
                                            <input class="form-control w-50" type="number" placeholder="Tax Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ order.currency ? order.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="order.subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="order.in_words" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="order.remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateType" class="btn btn-success mr-3">Create</button>
                                        <router-link to="/sales/order/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>

    <!-- Client Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add New Client" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <div class="form-group">
                <label>Name (Contact Person)</label>
                <input class="form-control" type="text" v-model="client.first_name">
            </div>

            <div class="form-group">
                <label>Company <span class="btn-success ml-3 p-1 rounded" v-b-modal.modal-prevent-closing-company>Add New </span></label>
                <select class="form-control digits" v-model="client.company" @change="getCompany">
                    <option v-for="(company, index) in companies" :key="index" :value="company.id">{{ company.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label>Designation</label>
                <input class="form-control" type="text" v-model="client.designation">
            </div>

            <div class="form-group">
                <label>Phone Number</label>
                <input class="form-control" type="text" v-model="client.phone">
            </div>

            <div class="form-group">
                <label>Email</label>
                <input class="form-control" type="text" v-model="client.email">
            </div>

            <div class="form-group">
                <label>Address</label>
                <input class="form-control" type="text" v-model="client.address">
            </div>
        </form>
    </b-modal>
    <!-- Container-fluid Ends-->

    <!-- Container-fluid Ends-->
    <b-modal id="modal-prevent-closing-company" ref="modal" title="Add Company" @show="resetCompanyModal" @hidden="resetClient" @ok="handleClientOk">
        <form ref="form" @submit.stop.prevent="handleClientSubmit">
            <b-form-group label="Company Name" label-for="name-input" invalid-feedback="Company Name is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.name" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="Email" label-for="name-input" invalid-feedback="Email address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.email" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="Website" label-for="name-input">
                <b-form-input id="name-input" v-model="company.website"></b-form-input>
            </b-form-group>

            <b-form-group label="Address" label-for="name-input" invalid-feedback="Company address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.address" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="BIN" label-for="name-input">
                <b-form-input id="name-input" v-model="company.bin"></b-form-input>
            </b-form-group>

            <b-form-group label="TIN" label-for="name-input">
                <b-form-input id="name-input" v-model="company.tin"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    toWords
} from 'number-to-words'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        'v-select': vSelect
    },

    data() {
        return {
            discountAmount: computed(() => {
                if (this.order.total !== 0) {
                    const discount = this.order.discount || 0;
                    let total = this.order.total + discount * (this.order.total / 100)
                    let gtotal = total - this.order.total

                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),
            basePrice: computed(() => {
                if (!this.order ?.total || !this.order ?.vat_type || !this.order ?.tax_type) return 0;

                const total = Number(this.order.total);
                const vat = Number(this.order.vat || 0);
                const tax = Number(this.order.tax || 0);

                if (this.order.vat_type === 'inclusive' && this.order.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.order.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.order.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.order ?.tax && this.order ?.tax_type && this.order ?.total) {
                    const vat = Number(this.order.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.order ?.vat && this.order ?.vat_type && this.order ?.total) {
                    const vat = Number(this.order.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),
            order: {
                quotation: null,
                project: null,
                email: '',
                currency: 'BDT',
                client_address: '',
                billing_address: '',
                order_date: null,
                order_attachment: null,
                due_date: null,
                client: '',
                details: null,
                details_in_depth: [],
                vat_type: '',
                tax_type: '',

                total: computed(() => {
                    let total = 0;
                    if (this.order.details_in_depth.length >= 1) {
                        this.order.details_in_depth.map((item) => {
                            total = total + item.rate;
                        });
                    }
                    return total;
                }),
                tax: null,
                vat: null,
                discount: null,
                subtotal: computed(() => {
                    if (!this.order ?.total || !this.order ?.vat_type || !this.order ?.tax_type) return 0;

                    const total = Number(this.order.total);
                    const discount = Number(this.order.discount || 0);

                    // Case 1: both VAT and TAX are inclusive → just apply discount to total
                    if (this.order.vat_type === 'inclusive' && this.order.tax_type === 'inclusive') {
                        const discounted = total - (total * discount / 100);
                        return Math.round((discounted + Number.EPSILON) * 100) / 100;
                    }

                    // Case 2: Exclusive taxes → add them first
                    let calculated = total;

                    if (this.order.vat_type === 'exclusive') {
                        calculated += this.vatAmount;
                    }

                    if (this.order.tax_type === 'exclusive') {
                        calculated += this.taxAmount;
                    }

                    // Apply discount to final calculated total
                    const discounted = calculated - (calculated * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }),
                in_words: '',
                remarks: ''
            },
            nameState: null,

            currencies: ['BDT', 'USD', 'EUR'],

            client: {
                first_name: '',
                company: null,
                designation: '',
                phone: '',
                email: '',
                address: '',
                status: true
            },

            company: {
                name: '',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: ''
            },
            vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            },
        };
    },

    computed: {
        ...mapState({
            // items: state => state.item.items,
            // items: state => state.inventory.product_without_pg,
            detail: state => state.quotation.quotation_detail,
            clients: state => state.client.client_without_pg,
            projects: state => state.project.project,
            quotations: state => state.quotation.quotation_withoutpg,
            companies: state => state.client.company
        })
    },

    mounted() {
        if (this.$route.params.id == 'new') {
            this.order.quotation = ''
        } else {
            this.order.quotation = Number(this.$route.params.id)
        }
        // this.$store.dispatch("inventory/fetchProductWithoutPG")
        // this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("project/fetchProject")
        this.$store.dispatch("quotation/fetchQuotationWithoutPG")
        this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("client/fetchCompany");
        this.$store.dispatch("quotation/fetchQuotationDetail", this.$route.params.id)
    },

    watch: {
        'order.quotation'(newVal) {
            if (newVal) {
                this.order.project = null // reset project when quotation selected
            }
        },
       
        detail: {
            handler(newValue, oldValue) {
             
                this.order.client = newValue.client ?.id || null
                this.order.project = newValue.project ?.id || null
                this.order.email = newValue.email || ''
                this.order.currency = newValue.currency || ''
                this.order.client_address = newValue.client_address || ''
                this.order.billing_address = newValue.billing_address || ''
                this.order.order_date = this.getCurrentDate()
                this.order.due_date = newValue.due_date || ''
                this.order.quotation_attachment = newValue.quotation_attachment || null
                this.order.details = newValue.details ? JSON.parse(newValue.details) : []
                this.order.details_in_depth = this.order.details
                this.order.total = newValue.total || 0
                this.order.vat = newValue.vat || 0
                this.order.tax = newValue.tax || 0
                this.order.vat_type = newValue.vat_type || ''
                this.order.tax_type = newValue.tax_type || ''
                this.order.discount = newValue.discount || 0
                this.order.subtotal = newValue.subtotal || 0
                this.order.in_words = newValue.in_words || ''
                this.order.remarks = newValue.remarks || ''
            },
            immediate: true,
            deep: true
        },
         'order.subtotal'(val) {
            if (!val) {
                this.order.in_words = ''
                return
            }

            const text = toWords(val)
            let formatted = text.replace(/\b\w/g, c => c.toUpperCase())

            if (this.order.currency) {
                formatted += ` ${this.order.currency} only`
            }

            this.order.in_words = formatted
        },
    },

    methods: {
        getCurrentDate() {
            const today = new Date()
            const yyyy = today.getFullYear()
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const dd = String(today.getDate()).padStart(2, '0')

            return `${yyyy}-${mm}-${dd}` // format: YYYY-MM-DD
        },
        validateType() {
            this.errors = {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            };

            let valid = true;

            if (!this.order.vat_type) {
                this.errors.vat_type = 'Vat type is required.';
                valid = false;
            }
            if (!this.order.tax_type) {
                this.errors.tax_type = 'Tax type is required.';
                valid = false;
            }
            if (!this.order.vat) {
                this.errors.vat = 'Vat is required.';
                valid = false;
            }
            if (!this.order.tax) {
                this.errors.tax = 'Tax is required.';
                valid = false;
            }

            if (valid) {
                this.onSubmit();
            }
        },
        uploadFile(e) {
            this.order.order_attachment = e.target.files[0];
        },

        getCompany() {
            this.$store.dispatch("client/fetchCompanyDetails", this.client.company).then(result => {
                this.client.address = result.data.address
            })
        },

        getClient() {
            this.$store.dispatch("client/fetchClientByUserId", this.order.client).then(result => {
                this.order.email = result.data.user.email
                this.order.client_address = result.data.company.address
                this.order.billing_address = result.data.company.address
            })
        },

        resetCompanyModal() {
            this.company.name = ''
            this.company.email = ''
            this.company.website = ''
            this.company.address = ''
            this.company.bin = ''
            this.company.tin = ''
            this.nameState = null
        },

        resetModal() {
            this.client.first_name = ''
            this.client.company = '',
                this.client.designation = '',
                this.client.phone = '',
                this.client.email = '',
                this.client.address = ''
        },

        updateItems(data) {
            if (data) {
                this.order.details_in_depth = data;
                this.order.details = data;
            }
        },

        onSubmit() {
            if (this.order.order_date !== null) {
                this.order.order_date = moment(String(this.order.order_date)).format("YYYY-MM-DD");
            }
            if (this.order.due_date !== null) {
                this.order.due_date = moment(String(this.order.due_date)).format("YYYY-MM-DD");
            }

            this.order.details = this.order.details ?.length > 0 ? this.order.details : null

            if (this.order.details) {
                this.$store.dispatch("order/addOrder", this.order).then(response => {
                    // console.log(response)
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });

                        setTimeout(() => {
                            this.$router.push('/sales/quotation/list')
                        }, 2000)

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                Swal.fire({
                    title: "Error!",
                    text: 'You must enter minimum 1 item',
                    icon: "error"
                });
            }
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("client/addClient", this.client).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.order.client = response.data.user
                    this.order.email = response.data.email
                    this.order.client_address = response.data.address
                    this.order.billing_address = response.data.address

                    this.client.first_name = '',
                        this.client.company = null,
                        this.client.designation = '',
                        this.client.phone = '',
                        this.client.email = '',
                        this.client.address = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },

        handleClientOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleClientSubmit()
        },

        handleClientSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("client/addCompany", this.company).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.client.company = response.data.id
                    this.client.address = response.data.address

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-company')
            })
        }
    }
};
</script>
